import axios from "axios"
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from "axios"

// 接口返回类型  *** 因后端返回不确定暂不使用
// type Result<T> = {
//   code: number
//   message: string
//   data: T
// }

class Request {
  // axios 实例
  instance: AxiosInstance
  // 基础配置，url和超时时间
  baseConfig: AxiosRequestConfig = { 
    baseURL: "", 
    headers: {
      // 'Content-Type': 'application/json'
    },
    withCredentials: true
  }

  constructor(config?: AxiosRequestConfig) {
    // console.log('initaxios')
    // 使用axios.create创建axios实例
    this.instance = axios.create(Object.assign(this.baseConfig, config))
    // 请求拦截器
    this.instance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        // console.log('项目请求拦截')
        // if(isNode()){
        //   console.info(`API ${config.url} request: ` )
        //   console.info(`headers: `, config.headers)
        //   console.info(`params: `, config.data)
        // }
        return config
      },
      (err: any) => {
        return Promise.reject(err)
      }
    )
    // 响应拦截器
    this.instance.interceptors.response.use(
      (response: AxiosResponse) => {
        // if(isNode()){
        //   console.info(`API ${response.config.url} response: `)
        //   console.info(`headers: `, response.config.headers)
        //   console.info(`params: `, response.config.data)
        //   console.info(`status: `, response.status)
        //   console.info(`data: `, response.data)
        // }
        return response.data
      },
      (error: AxiosError) => {
        return Promise.reject({
          Code: -1,
          error
        })
      }
    )
  }

  // 定义请求方法
  public request(config: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.instance.request(config)
  }

  public get(url: string, config?: AxiosRequestConfig): Promise<any> {
    return this.instance.get(url, config)
  }

  public post(url: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
    return this.instance.post(url, data, config)
  }

  public put(url: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
    return this.instance.put(url, data, config)
  }

  public delete(url: string, config?: AxiosRequestConfig): Promise<any> {
    return this.instance.delete(url, config)
  }
}

const http = new Request()
if (!(typeof window === "undefined")) {
  window.$axiosHtpp = http

}
export default http